"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPlaceBidResponseDto = instanceOfPlaceBidResponseDto;
exports.PlaceBidResponseDtoFromJSON = PlaceBidResponseDtoFromJSON;
exports.PlaceBidResponseDtoFromJSONTyped = PlaceBidResponseDtoFromJSONTyped;
exports.PlaceBidResponseDtoToJSON = PlaceBidResponseDtoToJSON;
exports.PlaceBidResponseDtoToJSONTyped = PlaceBidResponseDtoToJSONTyped;
/**
 * Check if a given object implements the PlaceBidResponseDto interface.
 */
function instanceOfPlaceBidResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function PlaceBidResponseDtoFromJSON(json) {
    return PlaceBidResponseDtoFromJSONTyped(json, false);
}
function PlaceBidResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
    };
}
function PlaceBidResponseDtoToJSON(json) {
    return PlaceBidResponseDtoToJSONTyped(json, false);
}
function PlaceBidResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
    };
}
